import { of } from "rxjs";
import { combineEpics } from "redux-observable";
import { loadFlightControlActionTypes, loadingFlightControl, loadedFlightControl, loadControlTowerExperienceActionTypes, loadingControlTowerExperience, loadedControlTowerExperience } from "../components/FlightDetails/FlightDetails.ducks.js";
import { loadOverviewActionTypes, loadingOverview, loadedOverview } from "../ducks/FlightOverview.ducks.js";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { getTenantFromManagementGroup } from "@ane/exp-data/lib/utils/ManagementGroup";
import FlightResource from "../resources/Flight.resource.js";
import { parseFlightOverviewDto, createExpIdScorecardMapping } from "../../../utils/FlightUtils.js";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models/IAsyncWrapper";
import { loadScorecardActionTypes, loadingScorecards, loadedScorecards } from "../components/FlightExperiments/FlightExperimentList.ducks.js";
import ExperimentResources from "@ane/exp-data/lib/resources/ExperimentResources";
import MdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import { loadFlightVariablesActionTypes, loadingFlightVariables, loadedFlightVariables } from "../components/FlightVariables/FlightVariables.ducks.js";
const loadFlightOverviewArgs = {
  filterOnType: loadOverviewActionTypes.LOAD,
  loadResource: (payload, state) => {
    return FlightResource.loadFlightOverview(payload.flightId, payload.workspaceId, payload.managementGroup);
  },
  loadingAction: (payload) => loadingOverview(payload),
  loadedAction: (successData, payload, error, errorContext) => {
    const result = getCompletedAsyncWrapperObj(
      (errorContext == null ? void 0 : errorContext.statusCode) === 301 ? successData : parseFlightOverviewDto(successData),
      error || "",
      errorContext
    );
    return of(loadedOverview(payload, result));
  }
};
const loadFlightOverviewEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadFlightOverviewArgs);
const loadScorecardDataArgs = {
  filterOnType: loadScorecardActionTypes.LOAD,
  loadResource: (payload, state) => {
    return ExperimentResources.scorecardData(payload.ids);
  },
  loadingAction: loadingScorecards,
  loadedAction: (successData, payload, error) => of(
    loadedScorecards(
      payload.flightId,
      getCompletedAsyncWrapperObj(createExpIdScorecardMapping(payload.ids, successData), error || "")
    )
  )
};
const loadScorecardDataEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadScorecardDataArgs);
const loadTreatmentVariablesArgs = {
  filterOnType: loadFlightVariablesActionTypes.LOAD,
  loadResource: (payload, state) => {
    const { flightId, workspaceId, managementGroup } = payload;
    return FlightResource.loadFlightTreatmentVariablesV2(
      flightId,
      workspaceId,
      managementGroup,
      getTenantFromManagementGroup(managementGroup)
    );
  },
  loadingAction: loadingFlightVariables,
  loadedAction: (successData, payload, error) => {
    var _a;
    const result = getCompletedAsyncWrapperObj((_a = successData == null ? void 0 : successData.TreatmentVariables) != null ? _a : [], error || "");
    return of(loadedFlightVariables(payload, result));
  }
};
const loadTreatmentVariablesEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadTreatmentVariablesArgs);
const loadFlightControlArgs = {
  filterOnType: loadFlightControlActionTypes.LOAD,
  loadResource: (payload, state) => {
    const { workspaceId, managementGroup } = payload;
    const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
    return MdsDataplaneResource.getConfigWithTypeV2({
      workspaceId,
      experimentationGroup,
      section: MasterDataConstants.flightControlSection
    });
  },
  loadingAction: loadingFlightControl,
  loadedAction: (successData, payload, error) => of(loadedFlightControl(payload.flightId, getCompletedAsyncWrapperObj(successData, error || "")))
};
const loadFlightControlEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadFlightControlArgs);
const loadControlTowerExperienceArgs = {
  filterOnType: loadControlTowerExperienceActionTypes.LOAD,
  loadResource: (payload, state) => {
    const { workspaceId, managementGroup } = payload;
    const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
    return MdsDataplaneResource.getConfigWithTypeV2({
      workspaceId,
      experimentationGroup,
      section: MasterDataConstants.controlTowerExperienceSection
    });
  },
  loadingAction: loadingControlTowerExperience,
  loadedAction: (successData, payload, error) => of(loadedControlTowerExperience(payload, getCompletedAsyncWrapperObj(successData, error || "")))
};
const loadControlTowerExperienceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadControlTowerExperienceArgs);
const flightEpic = combineEpics(
  loadFlightOverviewEpic,
  loadScorecardDataEpic,
  loadTreatmentVariablesEpic,
  loadFlightControlEpic,
  loadControlTowerExperienceEpic
);
export {
  flightEpic as default,
  loadControlTowerExperienceEpic,
  loadFlightControlEpic,
  loadFlightOverviewEpic,
  loadScorecardDataEpic,
  loadTreatmentVariablesEpic
};
//# sourceMappingURL=FlightDetailsEpic.js.map
